"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _uuid = require("uuid");
var _utils = require("@trs/utils");
var _config = require("@trs/config");
var _ShareDetailLegend = _interopRequireDefault(require("./ShareDetailLegend.style"));
var _currency = _interopRequireDefault(require("../currency"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ShareDetailLegend = function ShareDetailLegend(_ref) {
  var shareData = _ref.shareData,
    label = _ref.label,
    employeeCurrency = _ref.employeeCurrency,
    showVested = _ref.showVested,
    showUnvested = _ref.showUnvested;
  return /*#__PURE__*/_react["default"].createElement(_ShareDetailLegend["default"], null, shareData.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: (0, _uuid.v4)(),
      className: "share-legend-item ".concat(item.shareStatus)
    }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_currency["default"], {
      currency: "",
      decimals: _config.MAX_DECIMALS,
      shouldParseFloat: true
    }, item.count), " ".concat(item.shareStatus, " ").concat((0, _utils.toLower)(label.SHARES_PAGE_GROUP), " "), /*#__PURE__*/_react["default"].createElement("span", {
      className: "percentage"
    }, "(".concat(item.value, "%)"))), (item.shareStatus === 'vested' && showVested || item.shareStatus === 'unvested' && showUnvested) && /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(_currency["default"], {
      currency: R.path(['amount', 'currency'], item),
      decimals: _config.MAX_DECIMALS,
      shouldParseFloat: true
    }, R.path(['amount', 'value'], item)), ' ', R.path(['amount', 'currency'], item) !== employeeCurrency && /*#__PURE__*/_react["default"].createElement("span", null, "(", /*#__PURE__*/_react["default"].createElement(_currency["default"], {
      currency: R.path(['employeeAmount', 'currency'], item),
      decimals: _config.MAX_DECIMALS,
      shouldParseFloat: true
    }, R.path(['employeeAmount', 'value'], item)), ")")));
  }));
};
ShareDetailLegend.defaultProps = {
  showVested: true,
  showUnvested: true
};
ShareDetailLegend.propTypes = {
  /** List of shares with details */
  shareData: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  label: _propTypes["default"].shape({
    SHARES_PAGE_GROUP: _propTypes["default"].string
  }).isRequired,
  employeeCurrency: _propTypes["default"].string.isRequired,
  showVested: _propTypes["default"].bool,
  showUnvested: _propTypes["default"].bool
};
var _default = exports["default"] = ShareDetailLegend;